import api from "./api";
import type { ReadingGoal, ReadingGoalCreate, ReadingGoalUpdate } from "../types";
import { conditionalHeaders } from "./concurrency";

const ENDPOINT = "/reading-goals";

export const readingGoalService = {
  async list(signal?: AbortSignal): Promise<ReadingGoal[]> {
    const response = await api.get<ReadingGoal[]>(`${ENDPOINT}/`, { signal });
    return response.data;
  },
  async create(payload: ReadingGoalCreate): Promise<ReadingGoal> {
    const response = await api.post<ReadingGoal>(`${ENDPOINT}/`, payload);
    return response.data;
  },
  async update(
    goalId: number,
    payload: ReadingGoalUpdate,
    updatedAt?: string
  ): Promise<ReadingGoal> {
    const response = await api.patch<ReadingGoal>(`${ENDPOINT}/${goalId}`, payload, {
      headers: conditionalHeaders(updatedAt),
    });
    return response.data;
  },
  async remove(goalId: number, updatedAt?: string): Promise<void> {
    await api.delete(`${ENDPOINT}/${goalId}`, {
      headers: conditionalHeaders(updatedAt),
    });
  },
};
